export default __webpack_public_path__ + "static/media/Pilhas.1a3d9083.png";